import React from 'react';
import { Heading, Text, Box } from '@wix/design-system';
import { parseDomain } from '@wix/domains-serverless-interface';
import ExactMatch from '../../assets/images/exactMatch.svg';
import s from './TitleDisplay.module.scss';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import { DomainWithEllipsis } from '../DomainWithEllipsis';
import { ComBrRestriction } from './ComBrRestriction';
import { useIsMobile } from '@wix/core-domain-search';
const MOBILE_MAX_WIDTH = '260px';
export const TitleDisplay = _ref => {
  let {
    title,
    primary = false,
    exactMatch = false,
    titleClassName,
    isLeanView = false,
    isResultsPageOptimizations = false
  } = _ref;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  const titleClassNameSuffix = titleClassName ? ` ${titleClassName}` : '';
  const isMobile = useIsMobile();
  const showComBrRestriction = isResultsPageOptimizations && parseDomain(title).tld === 'com.br';
  if (exactMatch) {
    const exactMatchOptimizedClass = isResultsPageOptimizations ? ` ${s.exactMatchTitleOptimized}` : '';
    const domainEllipsis = /*#__PURE__*/React.createElement(DomainWithEllipsis, {
      maxWidth: isResultsPageOptimizations ? '100%' : isMobile ? MOBILE_MAX_WIDTH : '440px',
      textComponent: Heading,
      className: `${s.primaryTitle}${exactMatchOptimizedClass}${titleClassNameSuffix}`,
      textComponentProps: {
        as: 'span',
        size: 'large'
      }
    }, title);
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "7px"
    }, /*#__PURE__*/React.createElement(Box, {
      gap: "5px",
      align: "left",
      placeItems: "center",
      verticalAlign: "middle",
      className: s.exactMatch
    }, /*#__PURE__*/React.createElement(ExactMatch, {
      className: isMobile ? s.exactMatchIconMobile : s.exactMatchIcon
    }), isResultsPageOptimizations ? domainEllipsis : /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "domains_search_gate.storefront_results.optimized.domain_available",
      values: {
        domainName: title
      },
      components: [domainEllipsis]
    }))), /*#__PURE__*/React.createElement(ComBrRestriction, {
      domainName: title
    }));
  }
  const maxWidth = isMobile ? MOBILE_MAX_WIDTH : '520px';
  if (primary) {
    const primaryTitle = /*#__PURE__*/React.createElement(DomainWithEllipsis, {
      maxWidth: maxWidth,
      textComponent: Heading,
      className: `${s.primaryTitle}${titleClassNameSuffix}`,
      textComponentProps: {
        size: 'large'
      }
    }, title);
    return showComBrRestriction ? /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "4px"
    }, primaryTitle, /*#__PURE__*/React.createElement(ComBrRestriction, {
      domainName: title
    })) : primaryTitle;
  }
  const regularTitle = /*#__PURE__*/React.createElement(DomainWithEllipsis, {
    maxWidth: maxWidth,
    className: `${isResultsPageOptimizations ? s.regularTitleOptimized : isLeanView ? s.regularTitleLean : s.regularTitle}${titleClassNameSuffix}`
  }, title);
  return showComBrRestriction ? /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "4px"
  }, regularTitle, /*#__PURE__*/React.createElement(ComBrRestriction, {
    domainName: title
  })) : regularTitle;
};
//# sourceMappingURL=TitleDisplay.js.map